// extracted by mini-css-extract-plugin
export var menuItem = "J_wL g_hx g_dh g_dl g_dw g_h";
export var menuItemSub = "J_wM g_cL g_dh g_dw";
export var menuMainLink = "J_wN g_hy g_gj";
export var menuLink = "J_wP g_hy g_gj";
export var Link = "J_tr x_tr x_sM x_s5";